module.exports = "/wwwroot/img/collection_vehicle_search_block.png?ver=33fc861f";